import React, { Component } from "react";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { Fieldset } from "primereact/fieldset";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import logo from "../../Assests/RebelSkool.png";
import axios from "axios";
import { Toast } from "primereact/toast";
import "./Login.css";
import { Link } from "react-scroll";
import { connect } from "react-redux";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import "./ForgetPassword.css";
import forgotPassword from "../../Assests/forgotpassword.jpg";

import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Divider } from "primereact/divider";
import { Sidebar } from "primereact/sidebar";
import { RiArrowDownSFill } from "react-icons/ri";
import { Dialog } from "primereact/dialog";
import { InputMask } from "primereact/inputmask";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { validateEmail } from "./utils";
import usePasswordValidator from "./usePasswordValidator";
import { FcApproval, FcCancel } from "react-icons/fc";
import { TabView, TabPanel } from "primereact/tabview";

let userSelectedLanguage;
const mapStateToProps = (state) => {
  return {
    annualReportType: state.annualReportType.annualReportType.values,
    companyInformation: state.companyInformation.companyInformation.values,
    financialYear: state.financialYear.financialYear,
    incomeStatement: state.incomeStatement.incomeStatement,
    sessionDetails: state.sessionDetails,
    sideBarReducer: state.sideBarReducer.sideBarReducer,
    language: state.language.language,
    activeSideBar: state.activeSideBar.activeSideBar,
    prices: state.prices.prices,
    currentPageName: state.currentPageName.currentPageName,
    login: state.login.login,
    pricesToLogin: state.pricesToLogin.pricesToLogin
  };
};

class ForgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resetEmail: "",
      resetPassword: "",
      resetConfirmPassword: "",
      newPassword: "",
      showPasswordTooltip: false,
      passwordValidation: {
        minLength: false,
        uppercase: false,
        number: false,
        specialChar: false
      },
      isResetPasswordMismatch: true,
      isResetConfirmPasswordBlur: false,
      isMasked: true
    };
    this.passwordInputRef = React.createRef();
  }

  resetPasswordOnChange(e) {
    const minLength = e.length >= 6;
    const uppercase = /[A-Z]/.test(e);
    const number = /[0-9]/.test(e);
    const specialChar = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(e);
    const isPasswordValid = minLength && uppercase && number && specialChar;

    this.setState({
      resetPassword: e,
      showPasswordTooltip: e.length > 0 && !isPasswordValid,
      passwordValidation: {
        minLength,
        uppercase,
        number,
        specialChar
      }
    });
  }

  resetPasswordOnBlur() {
    const { resetConfirmPassword, resetPassword } = this.state;
    if (resetConfirmPassword != "") {
      if (resetPassword == resetConfirmPassword) {
        this.setState({
          isResetPasswordMismatch: false
        });
      } else {
        this.setState({
          isResetPasswordMismatch: true
        });
      }
    }
  }

  handleResetButtonClick = () => {
    const { resetPassword, resetConfirmPassword, passwordValidation } =
      this.state;

    const isPasswordValid =
      passwordValidation.minLength &&
      passwordValidation.uppercase &&
      passwordValidation.number &&
      passwordValidation.specialChar;

    if (!isPasswordValid || resetPassword === "") {
      this.setState({ showPasswordTooltip: true });
      if (this.passwordInputRef.current) {
        this.passwordInputRef.current.focus();
      }
      return;
    }

    // Passwords don't match
    if (resetConfirmPassword === "" || resetPassword !== resetConfirmPassword) {
      this.setState({
        isResetPasswordMismatch: true,
        isResetConfirmPasswordBlur: true
      });
      return;
    }

    this.resetTheNewPassword();
  };

  toggleMask = () => {
    this.setState((prevState) => ({
      isMasked: !prevState.isMasked
    }));
  };

  resetConfirmPasswordOnChange(e) {
    this.setState({
      resetConfirmPassword: e
    });
  }

  resetConfirmPasswordOnBlur() {
    const { resetConfirmPassword, resetPassword, isResetConfirmPasswordBlur } =
      this.state;
    if (resetConfirmPassword != "") {
      this.setState({
        isResetConfirmPasswordBlur: true
      });
      if (resetConfirmPassword == resetPassword) {
        this.setState({
          isResetPasswordMismatch: false
        });
      } else {
        this.setState({
          isResetPasswordMismatch: true
        });
      }
    }
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    let navigateTo = localStorage.getItem("navigateTo");
    if (navigateTo == "dashboard") {
      localStorage.setItem("navigateTo", "");
      window.location.assign("/#/annualreport");
    }
  }

  resetTheNewPassword() {
    const { resetPassword, resetConfirmPassword } = this.state;
    const { login } = this.props;
    if (resetPassword != "" && resetConfirmPassword != "") {
      let currentPageUrl = window.location.href;
      let splitCurrentPageUrl = currentPageUrl.split("/");
      let userGUID = "";
      if (splitCurrentPageUrl.length == 6) {
        userGUID = splitCurrentPageUrl[4];
      }

      let userResetPasswordWithUserGUID = {
        userGUID: userGUID,
        password: resetPassword
      };

      axios
        .post("/user/updatePasswordForUserGUID", userResetPasswordWithUserGUID)
        .then((response) => {
          if (response.data) {
            this.setState({ resetPassword: "", resetConfirmPassword: "" });
            this.toast.show({
              severity: "success",
              summary: TranslationFile.SuccessText[userSelectedLanguage],
              detail: TranslationFile.PassResetSuces[userSelectedLanguage],
              life: 3000
            });

            // setTimeout(() => {
            //   window.location.assign("/#/annualreport");
            // }, 3000);

            axios
              .get("/user/getByGuid?userGUID=" + userGUID)
              .then((userDetailsResponse) => {
                if (userDetailsResponse.data) {
                  let resp = userDetailsResponse.data;
                  let emailIdFromResp = resp.emailID;

                  let userEmailPasswordDetails = {
                    emailID: emailIdFromResp,
                    password: resetPassword,
                    checkHashCode: true
                  };

                  if (
                    userEmailPasswordDetails.emailID != "" &&
                    userEmailPasswordDetails.password != ""
                  ) {
                    this.toast.show({
                      severity: "success",
                      summary:
                        TranslationFile.SuccessText[userSelectedLanguage],
                      detail:
                        TranslationFile.redirectingToHome[userSelectedLanguage],
                      // life: 3000,
                      sticky: true
                    });
                    axios
                      .post("/user/loginAndGetUser", userEmailPasswordDetails)
                      .then((loginResponse) => {
                        const userAuthKey = response.headers.usersessionauthkey;
                        login.values = loginResponse.data;
                        loginResponse.data["userSessionAuthKey"] = userAuthKey;
                        localStorage.setItem(
                          "rebelSkoolUser",
                          JSON.stringify(loginResponse.data)
                        );
                        localStorage.setItem("navigateTo", "dashboard");
                        window.location.reload(false);
                      });
                  } else {
                    this.toast.show({
                      severity: "error",
                      summary: TranslationFile.errorText[userSelectedLanguage],
                      detail:
                        TranslationFile.PassEmptyMes[userSelectedLanguage],
                      life: 3000
                    });
                  }
                }
              });
          }
        });
    }
  }

  render() {
    const {
      isMasked,
      resetEmail,
      resetPassword,
      resetConfirmPassword,
      isResetPasswordMismatch,
      isResetConfirmPasswordBlur,
      passwordValidation,
      showPasswordTooltip
    } = this.state;

    // Check if all rules pass
    const isPasswordValid =
      passwordValidation.minLength &&
      passwordValidation.uppercase &&
      passwordValidation.number &&
      passwordValidation.specialChar;

    return (
      <div className="forgot-password-main-div">
        <Toast ref={(el) => (this.toast = el)} style={{ marginTop: "80px" }} />

        {/* Responsive container Layout */}
        <div className="forget-password-wrapper">
          {/* New Wrapper Layout for split view */}
          {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "40px",
            minHeight: "100vh",
            padding: "20px"
          }}
        > */}
          {/* Left Side: 3D Illustration Image */}
          <div
            className="forget-password-image-side"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Image
              src={forgotPassword}
              alt="Forgot Password Illustration"
              /*  width="450" */
              className="responsive-hero-img"
            />
          </div>

          {/* Right Side: Your Existing Form Container */}
          <div
            className="forget-password-container" /* style={{ margin: "0" }} */
          >
            <center>
              <div className="forget-password-logo">
                <Link to="/">
                  <Image src={logo} alt="Image" width="200" />
                </Link>
              </div>
            </center>

            <Fieldset
              legend={TranslationFile.loginForgotPass[userSelectedLanguage]}
            >
              <div>
                <div>
                  <center>
                    {
                      TranslationFile.EnterNewpassToResetText[
                        userSelectedLanguage
                      ]
                    }
                  </center>
                  <br></br>
                  <center>
                    <div className="p-inputbox">
                      {/* Password Input */}
                      <input
                        id="resetPasswordInput"
                        ref={this.passwordInputRef}
                        type={isMasked ? "password" : "text"}
                        value={resetPassword}
                        data-tooltip-id="password-requirements"
                        onChange={(e) => {
                          this.resetPasswordOnChange(e.target.value);
                        }}
                        onFocus={() => {
                          const password = this.state.resetPassword;

                          const validation = {
                            minLength: password.length >= 6,
                            uppercase: /[A-Z]/.test(password),
                            number: /[0-9]/.test(password),
                            specialChar:
                              /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
                                password
                              )
                          };

                          this.setState({
                            passwordValidation: validation,
                            // REMOVED "password.length > 0 &&" so it shows even if empty
                            showPasswordTooltip: !(
                              validation.minLength &&
                              validation.uppercase &&
                              validation.number &&
                              validation.specialChar
                            )
                          });
                        }}
                        onBlur={() => {
                          this.resetPasswordOnBlur();
                          this.setState({
                            showPasswordTooltip: false
                          });
                        }}
                        placeholder={
                          TranslationFile.NewPassText[userSelectedLanguage]
                        }
                        className="p-inputtext p-component"
                        autoComplete="new-password"
                      />

                      {/* Toggle Icon */}
                      <span
                        className="p-inputgroup-addon"
                        onClick={this.toggleMask}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className={isMasked ? "pi pi-eye-slash" : "pi pi-eye"}
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                      </span>
                    </div>

                    <Tooltip
                      anchorSelect="#resetPasswordInput"
                      id="password-requirements"
                      isOpen={showPasswordTooltip}
                      place="left"
                      offset={10}
                      openEvents={{}}
                      closeEvents={{}}
                      globalCloseEvents={{}}
                      clickable
                      className="password-tooltip"
                      style={{
                        zIndex: 9999,
                        backgroundColor: "#ffb3ff",
                        color: "#ff0000",
                        borderRadius: "8px",
                        padding: "10px"
                      }}
                    >
                      <>
                        <b className="passwordReqTooltipHeader">
                          {
                            TranslationFile.passwordRequirements[
                              userSelectedLanguage
                            ]
                          }
                        </b>
                      </>
                      <hr className="passwordReqTooltipHeaderHrTag"></hr>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                          fontWeight: "500"
                        }}
                      >
                        <div
                          style={{
                            color: passwordValidation.minLength
                              ? "green"
                              : "red"
                          }}
                        >
                          {passwordValidation.minLength ? "✓" : "✗"}{" "}
                          {
                            TranslationFile.minimum6characters[
                              userSelectedLanguage
                            ]
                          }
                        </div>

                        <div
                          style={{
                            color: passwordValidation.uppercase
                              ? "green"
                              : "red"
                          }}
                        >
                          {passwordValidation.uppercase ? "✓" : "✗"}{" "}
                          {
                            TranslationFile.atleast1uppercaseletter[
                              userSelectedLanguage
                            ]
                          }
                        </div>

                        <div
                          style={{
                            color: passwordValidation.number ? "green" : "red"
                          }}
                        >
                          {passwordValidation.number ? "✓" : "✗"}{" "}
                          {TranslationFile.atleast1number[userSelectedLanguage]}
                        </div>

                        <div
                          style={{
                            color: passwordValidation.specialChar
                              ? "green"
                              : "red"
                          }}
                        >
                          {passwordValidation.specialChar ? "✓" : "✗"}{" "}
                          {
                            TranslationFile.atleast1specialcharacter[
                              userSelectedLanguage
                            ]
                          }
                        </div>
                      </div>
                    </Tooltip>

                    <br></br>
                    <br></br>
                    <div className="p-inputbox">
                      <input
                        type={isMasked ? "password" : "text"}
                        value={resetConfirmPassword}
                        onChange={(e) => {
                          this.resetConfirmPasswordOnChange(e.target.value);
                        }}
                        onBlur={() => this.resetConfirmPasswordOnBlur()}
                        placeholder={
                          TranslationFile.ConfirmPassText[userSelectedLanguage]
                        }
                        className="p-inputtext p-component"
                      />

                      {/* Toggle Icon */}
                      <span
                        className="p-inputgroup-addon"
                        onClick={this.toggleMask}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className={isMasked ? "pi pi-eye-slash" : "pi pi-eye"}
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                      </span>
                    </div>

                    {isResetPasswordMismatch &&
                      resetPassword != "" &&
                      resetConfirmPassword != "" &&
                      isResetConfirmPasswordBlur && (
                        <div className="error">
                          {
                            TranslationFile.PasswordMustMatchText[
                              userSelectedLanguage
                            ]
                          }
                        </div>
                      )}

                    <br></br>
                  </center>
                </div>
                <center>
                  <Button
                    label={TranslationFile.ResetPassText[userSelectedLanguage]}
                    aria-label={
                      TranslationFile.yearBtnSaveText[userSelectedLanguage]
                    }
                    className="year-btn-save"
                    style={{
                      width: "250px",
                      height: "44px",
                      fontSize: "1.2rem",
                      marginTop: "6%",
                      color: "white",
                      opacity:
                        resetPassword != "" &&
                        resetConfirmPassword != "" &&
                        resetPassword == resetConfirmPassword &&
                        !isResetPasswordMismatch &&
                        isPasswordValid
                          ? 1
                          : 0.6
                    }}
                    onClick={this.handleResetButtonClick}
                  />
                </center>
              </div>
            </Fieldset>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(ForgetPassword);
